import { render, staticRenderFns } from "./BarcharSinPrecio.vue?vue&type=template&id=736a0ce7&"
import script from "./BarcharSinPrecio.vue?vue&type=script&lang=js&"
export * from "./BarcharSinPrecio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports